<template>
    <div id="timeline-year-project-list">
        <div v-if="projects.length">
            <div class="single" v-for="(project, p) in projects" :key="p">
                <p v-if="project.Show">
                    <span class="btn link" @click="$emit('view-project', project)">{{ project.Project }}</span> &mdash; <span class="project-date">{{ ProjectDate(project.Start, project.End) }}</span>
                </p>
            </div>
        </div>
        <div v-else>
            <p class="single">Projects pending, stay tuned!</p>
        </div>
    </div>
</template>

<script>
import { FormattedDate } from "@/assets/JS/Master.js";

export default {
    name: "PopupTimelineYearProjectList",
    props: { projects: Array },
    methods: {
        ProjectDate: function(dateStart, dateEnd) {
            return new FormattedDate("Descriptive", dateStart, dateEnd).output;
        }
    },
    emits: [ "view-project" ]
};
</script>